import type { AxiosInstance } from "axios";
import type {
  SendVerificationCodeResult,
  ValidateVerificationCodeResult,
} from "@shared/schemas/email-verification.schemas";
import type { UserIsolationStatus } from "@shared/schemas/user-isolation.schemas";

export function createAccountApi(apiClient: AxiosInstance) {
  return {
    async getUserEventsAsParticipant(): Promise<readonly unknown[]> {
      const response = await apiClient.get<readonly unknown[]>(
        "/api/v1/users/me/events",
      );
      return response.data;
    },

    async getIsolationStatus(): Promise<UserIsolationStatus> {
      const response = await apiClient.get<UserIsolationStatus>(
        "/api/v1/users/me/isolated",
      );
      return response.data;
    },

    async sendVerificationEmail(): Promise<SendVerificationCodeResult> {
      const response = await apiClient.post<SendVerificationCodeResult>(
        "/api/v1/users/me/email/verification",
      );
      return response.data;
    },

    async validateVerificationCode(
      code: string,
    ): Promise<ValidateVerificationCodeResult> {
      const response = await apiClient.put<ValidateVerificationCodeResult>(
        "/api/v1/users/me/email/verification",
        { code },
      );
      return response.data;
    },
  };
}
